/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { CartItem } from '../../../../Data/CartItem';
import { Currencies } from '../../../../Util/currencies';
import { useAppSelector } from '../../../../../Redux/Store/hooks';

// Define the props interface for the component
interface CartItemHeaderProps {
  articleName: string;
  articleVariant: string;
  itemQuantity: number;
  onQuantityChange: (cartItem: CartItem, quantity: number) => void;
  onRemoveItem: (cartItem: CartItem) => void;
  itemPrice: number;
  priceCurrency: number;
  cartItem: CartItem;
}

export function CartItemHeader({
  articleName,
  articleVariant,
  itemQuantity,
  onQuantityChange,
  onRemoveItem,
  itemPrice,
  priceCurrency,
  cartItem,
} : CartItemHeaderProps) : JSX.Element {

  const [globalShowPrices, setGlobalShowPrices] = useState<boolean>(false);

  useEffect(() => {
    const root = document.documentElement;
    const computedStyle = getComputedStyle(root);

    const showPricesValue = computedStyle.getPropertyValue('--show-prices').trim();
    setGlobalShowPrices(showPricesValue === 'true');
  }, []);

  // Handle quantity changes
  const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newQuantity = parseInt(e.target.value, 10);
    onQuantityChange(cartItem, newQuantity);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const selectedLanguage = useAppSelector((state) => {
    return state.TextsReducer.language;
  })!;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const translations = useAppSelector((state) => {
    return state.TextsReducer.translation;
  })!;

  // Handle remove item
  const handleRemoveItem = () => {
    onRemoveItem(cartItem);
  };

  const articleVariantTranslated = articleVariant;
  const variantName = articleVariantTranslated !== '' ? `(${articleVariantTranslated})` : '';
  const articleNameTranslated = articleName;
  const itemPriceWithCurrency = Currencies.formatPrice(itemPrice * itemQuantity, priceCurrency);
  return (
    <div
      className="cartItemHeader"
      style={
        {
          borderBottom: '1px solid #444444',
          borderTop: '1px solid #444444',
          display: 'flex',
          width: '100%',
          padding: '5px',
        }
      }
    >
      <h3 className="cartItemArticleAndVariant" style={{ textAlign: 'left', flex: '85%' }}>
        <span style={{ fontWeight: 'bold' }}>
          {`${articleNameTranslated}    `}
        </span>
        <span>
          {` ${variantName}`}
        </span>
      </h3>
      <div className="cartItemPriceAndQuantity" style={{ flex: '20%', textAlign: 'right' }}>
        <div className="cartItemQuantity" style={{ display: 'flex', width: '100%' }}>
          <button
            type="button"
            className="btn btn-outline-danger rounded"
            aria-label="Remove Item"
            onClick={handleRemoveItem}
            style={{ width: '40px', marginRight: '5px' }}
          >
            X
          </button>
          <input
            type="number"
            value={itemQuantity}
            onChange={handleQuantityChange}
            style={{ width: '80px', marginRight: '5px', textAlign: 'right' }}
          />
          { globalShowPrices
            ? (
              <div
                className="cartItemPrice"
                style={
                  {
                    width: '100px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '5px',
                    textAlign: 'right',
                    justifyContent: 'right',
                  }
                }
              >
                {itemPriceWithCurrency}
              </div>
            ) : (
              <div />
            )}
        </div>
      </div>
    </div>
  );
}

export default CartItemHeader;
